/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { SmsTimelineMessageDirection } from "./SmsTimelineMessageDirection";

export interface SmsTimelineMessage {
  /** inbound = a text the user sent us; outbound = an SMS notification we sent */
  direction: SmsTimelineMessageDirection;
  /** When the message was sent or received */
  timestamp: string;
  /** Message text */
  body: string;
  /** Source type of the message (e.g. user_input, ai_outreach, ai_response) */
  kind: string;
}
